// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"3e04503b","1551":"3e04503b","2560":"247567f4","3064":"757b01e8","3329":"2077ce1e","5156":"7ca5b2fb","5351":"3e04503b","5490":"3e04503b","8289":"fad13a90"}[chunkId] + ".chunk.css";
};